import { Box, Button, Image, Text, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { colors } from "../../styles";

interface IStatusPageProps {
    badgeText: string;
    iconSrc: string;
    iconAlt: string;
    title: string;
    descriptions: string[];
    buttonText: string;
    buttonTo?: string;
    onButtonClick?: () => void;
    minHeight?: string;
    buttonVariant?: "primary" | "secondary";
}

export default function StatusPage({
    badgeText,
    iconSrc,
    iconAlt,
    title,
    descriptions,
    buttonText,
    buttonTo,
    onButtonClick,
    minHeight = "100vh",
    buttonVariant = "primary",
}: IStatusPageProps) {

    const isPrimaryButton = buttonVariant === "primary";

    const button = (
        <Button
            width={"100%"}
            height={16}
            backgroundColor={isPrimaryButton ? colors.blue : colors.white}
            color={isPrimaryButton ? colors.white : colors.g2}
            border={"1.5px solid"}
            borderColor={isPrimaryButton ? colors.blue : colors.g4}
            borderRadius={12}
            fontSize={15}
            fontWeight={700}
            _hover={{
                backgroundColor: isPrimaryButton ? colors.dark : colors.g5,
            }}
            onClick={onButtonClick}
        >
            {buttonText}
        </Button>
    );

    return (
        <VStack
            width={"100%"}
            minHeight={minHeight}
            justifyContent={"center"}
            alignItems={"center"}
            padding={{
                base: 5,
                md: 10,
            }}
            backgroundColor={colors.g5}
        >
            <VStack
                width={"100%"}
                maxWidth={480}
                gap={8}
                padding={{
                    base: 8,
                    md: 10,
                }}
                backgroundColor={colors.white}
                border={"1px solid"}
                borderColor={colors.g4}
                borderRadius={24}
                boxShadow={"0 18px 45px rgba(18, 18, 18, 0.08)"}
                textAlign={"center"}
            >
                <VStack gap={4}>
                    <Box
                        paddingX={3}
                        paddingY={1}
                        backgroundColor={colors.light}
                        borderRadius={"full"}
                    >
                        <Text fontSize={13} fontWeight={700} color={colors.blue}>
                            {badgeText}
                        </Text>
                    </Box>

                    <Box
                        width={96}
                        height={96}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        // backgroundColor={colors.light}
                        borderRadius={"full"}
                    >
                        <Image src={iconSrc} alt={iconAlt} width={52} height={52} objectFit={"contain"} />
                    </Box>
                </VStack>

                <VStack gap={3}>
                    <Text fontSize={{ base: 24, md: 28 }} fontWeight={800} color={colors.g1}>
                        {title}
                    </Text>

                    <VStack gap={1}>
                        {descriptions.map((description) => (
                            <Text key={description} fontSize={15} fontWeight={500} color={colors.g2}>
                                {description}
                            </Text>
                        ))}
                    </VStack>
                </VStack>

                <Box width={"100%"}>
                    {buttonTo ? (
                        <Link to={buttonTo} style={{ display: "block" }}>
                            {button}
                        </Link>
                    ) : (
                        button
                    )}
                </Box>
            </VStack>
        </VStack>
    );
}
